<template>
  <div>
    <!-- prop tabindex ต้องใส่เพื่อให้ เป็น interactive ไม่เช่นนั้นจะ trigger blur ไม่ได้ -->
    <div
      ref="favoriteNote"
      :tabindex="-1"
      class="fav-note-icon-container"
      aria-hidden="true"
      title="โน๊ตใช้ประจำ และการแปลงเสียง"
    >
      <i class="fas fa-sticky-note background-icon"></i>
      <i class="fas fa-microphone foreground-icon"></i>
    </div>

    <b-popover
      :target="() => $refs.favoriteNote"
      triggers="click blur"
      custom-class="notes-transcription-popover"
      placement="top"
      boundary="viewport"
      :boundary-padding="10"
    >
      <div class="popover-content">
        <!-- Recent Transcriptions Section -->
        <div class="section transcription-section">
          <div class="section-header">
            <div class="section-title">
              <i class="fas fa-microphone section-icon"></i>
              <span class="section-label">การแปลงเสียงวันนี้</span>
            </div>
            <span
              v-if="recentTranscriptions.length > 0"
              class="section-count"
              >{{ recentTranscriptions.length }}</span
            >
          </div>
          <div class="section-content">
            <!-- Transcription items -->
            <div
              v-for="transcription in recentTranscriptions"
              :key="transcription.id"
              class="content-item transcription-item"
              @click="handleTranscriptionClicked(transcription.text)"
            >
              <div class="item-header">
                <span class="item-time">{{
                  formatTime(transcription.timestamp)
                }}</span>
                <i class="fas fa-chevron-right item-arrow"></i>
              </div>
              <div class="item-content">
                {{ getPreview(transcription.text) }}
              </div>
            </div>

            <!-- Empty state for no transcriptions today -->
            <div
              v-if="recentTranscriptions.length === 0"
              class="content-item empty-state transcription-empty"
            >
              <div class="empty-content">
                <i class="fas fa-microphone-slash empty-icon"></i>
                <span>ยังไม่มีการแปลงเสียงวันนี้</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Section Divider -->
        <div
          v-if="recentTranscriptions.length > 0 && arrayList.length > 0"
          class="section-divider"
        ></div>

        <!-- Favorite Notes Section -->
        <div class="section favorites-section">
          <div class="section-header">
            <div class="section-title">
              <i class="fas fa-star section-icon"></i>
              <span class="section-label">โน๊ตใช้ประจำ</span>
            </div>
            <div class="section-actions">
              <span v-if="arrayList.length > 0" class="section-count">{{
                arrayList.length
              }}</span>
              <button
                class="edit-btn"
                @click="openEditModal"
                title="แก้ไขโน๊ตใช้ประจำ"
              >
                <i class="fas fa-edit"></i>
              </button>
            </div>
          </div>
          <div class="section-content">
            <div
              v-if="arrayList.length === 0"
              class="content-item empty-state"
              @click="openEditModal"
            >
              <div class="empty-content">
                <i class="fas fa-plus-circle empty-icon"></i>
                <span>เพิ่มโน๊ตใช้ประจำ</span>
              </div>
            </div>
            <div
              v-for="(list, index) in arrayList"
              :key="index"
              class="content-item favorite-item"
              @click="handleFavoriteClicked(list)"
            >
              <div class="item-content">
                {{ list }}
              </div>
              <i class="fas fa-chevron-right item-arrow"></i>
            </div>
          </div>
        </div>
      </div>
    </b-popover>
    <EditFavNoteModal
      ref="editFavNoteModal"
      :storageName="storageName"
      @updateList="arrayList = $event"
    />
  </div>
</template>

<script>
import EditFavNoteModal from "@/components/modal/EditFavNote";

export default {
  name: "FavouriteNoteButton",
  components: { EditFavNoteModal },
  props: {
    storageName: String,
  },

  data() {
    return {
      selected: "",
      arrayList: [],
      recentTranscriptions: [],
    };
  },
  computed: {
    parentStyle() {
      return `height: ${this.height}px`;
    },
  },
  methods: {
    handleClicked(e) {
      this.$emit("listClicked", e);
    },
    handleFavoriteClicked(text) {
      this.$emit("listClicked", text);
    },
    handleTranscriptionClicked(text) {
      this.$emit("listClicked", text);
    },
    openEditModal() {
      this.$refs.editFavNoteModal.show();
    },
    loadTranscriptions() {
      try {
        const saved = localStorage.getItem("transcriptionHistory");
        if (saved) {
          const allTranscriptions = JSON.parse(saved);
          // Show last 5 recent transcriptions
          this.recentTranscriptions = allTranscriptions.slice(0, 5); // Show max 5 recent transcriptions
        }
      } catch (error) {
        console.warn("Unable to load transcription history:", error);
        this.recentTranscriptions = [];
      }
    },
    formatTime(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      return date.toLocaleTimeString("th-TH", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    getPreview(text) {
      if (!text) return "";
      return text.length > 40 ? text.substring(0, 40) + "..." : text;
    },
    onTranscriptionUpdated(event) {
      // Use the updated transcription data from the event for better performance
      if (event.detail) {
        const allTranscriptions = event.detail;
        // Show last 5 recent transcriptions
        this.recentTranscriptions = allTranscriptions.slice(0, 5); // Show max 5 recent transcriptions
      } else {
        // Fallback to loading from localStorage
        this.loadTranscriptions();
      }
    },
  },
  mounted() {
    let list = localStorage.getItem(this.storageName);
    this.arrayList = list ? JSON.parse(list) : [];
    this.loadTranscriptions();

    // Refresh transcriptions when localStorage changes (e.g., new transcription added)
    window.addEventListener("storage", this.loadTranscriptions);

    // Listen for custom transcription update events
    window.addEventListener(
      "transcriptionHistoryUpdated",
      this.onTranscriptionUpdated
    );
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.loadTranscriptions);
    window.removeEventListener(
      "transcriptionHistoryUpdated",
      this.onTranscriptionUpdated
    );
  },
};
</script>

<style>
/* FavNote Icon Container - Positioned at top-right of textarea */
.fav-note-icon-container {
  position: absolute;
  top: 6px;
  right: 8px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 10;
}

.fav-note-icon-container:hover {
  transform: translateY(-1px);
}

.fav-note-icon-container:active {
  transform: translateY(0);
}

.icon-overlay {
  position: relative;
  width: 100%;
  height: 100%;
}

.background-icon {
  font-size: 22px;
  color: #6b7280;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: all 0.2s ease;
}

.foreground-icon {
  font-size: 12px;
  color: white;
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 2;
  transition: all 0.2s ease;
}

.fav-note-icon-container:hover .background-icon {
  color: #4b5563;
  transform: scale(1.05);
}

.fav-note-icon-container:hover .foreground-icon {
  color: #f8fafc;
}

/* Mobile maintains same size as desktop */
@media (max-width: 768px) {
  .fav-note-icon-container {
    width: 28px;
    height: 28px;
    top: 6px;
    right: 6px;
  }

  .background-icon {
    font-size: 22px;
  }

  .foreground-icon {
    font-size: 12px;
  }
}

/* Popover Container - Override Bootstrap defaults */
.notes-transcription-popover {
  border: none !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  max-width: none !important;
  width: 400px !important;
}

.notes-transcription-popover .popover-body {
  padding: 0 !important;
  width: 400px !important;
  max-width: 400px !important;
}

.popover-content {
  width: 100%;
  max-height: 350px;
  overflow: hidden;
  background: white;
}

/* Section Layout */
.section {
  background: white;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  border-bottom: 1px solid #e8ecf4;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-icon {
  width: 16px;
  height: 16px;
  font-size: 14px;
}

.transcription-section .section-icon {
  color: #3b82f6;
}

.favorites-section .section-icon {
  color: #8b5cf6;
}

.section-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  letter-spacing: -0.01em;
}

.section-count {
  background: #e5e7eb;
  color: #6b7280;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
}

.section-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-btn {
  background: none;
  border: none;
  padding: 4px;
  border-radius: 6px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-btn:hover {
  background: #f3f4f6;
  color: #374151;
}

/* Section Content */
.section-content {
  max-height: 140px;
  overflow-y: auto;
  padding: 2px;
}

.content-item {
  padding: 6px 8px;
  margin: 1px 0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  position: relative;
}

.content-item:hover {
  background: #f8fafc;
  border-color: #e2e8f0;
  transform: translateY(-1px);
}

.content-item:active {
  transform: translateY(0);
}

/* Transcription Items */
.transcription-item {
  background: linear-gradient(135deg, #fafbff 0%, #f0f4ff 100%);
  border: 1px solid #e0e7ff;
}

.transcription-item:hover {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border-color: #bfdbfe;
}

.item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
}

.item-time {
  font-size: 10px;
  font-weight: 600;
  color: #3b82f6;
  background: white;
  padding: 1px 4px;
  border-radius: 3px;
  border: 1px solid #bfdbfe;
}

.item-content {
  font-size: 12px;
  line-height: 1.3;
  color: #4b5563;
}

.item-arrow {
  color: #9ca3af;
  font-size: 10px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.content-item:hover .item-arrow {
  opacity: 1;
}

/* Favorite Items */
.favorite-item {
  background: linear-gradient(135deg, #f8faff 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.favorite-item:hover {
  background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);
  border-color: #c4b5fd;
}

.favorite-item .item-content {
  flex: 1;
  font-size: 12px;
  line-height: 1.3;
  color: #4c1d95;
  font-weight: 500;
}

/* Empty State */
.empty-state {
  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
  border: 2px dashed #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  text-align: center;
}

.empty-state:hover {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  border-color: #9ca3af;
}

/* Transcription Empty State */
.transcription-empty {
  background: linear-gradient(135deg, #fafbff 0%, #f0f4ff 100%);
  border: 2px dashed #bfdbfe;
  cursor: default;
}

.transcription-empty:hover {
  background: linear-gradient(135deg, #fafbff 0%, #f0f4ff 100%);
  border-color: #bfdbfe;
  transform: none;
}

.transcription-empty .empty-icon {
  color: #3b82f6;
}

.transcription-empty .empty-content span {
  color: #3b82f6;
}

.empty-content {
  display: flex;
  align-items: center;
  gap: 6px;
}

.empty-icon {
  font-size: 14px;
  color: #9ca3af;
}

.empty-content span {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

/* Section Divider */
.section-divider {
  height: 4px;
  background: linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%);
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
}

/* Custom Scrollbar */
.section-content::-webkit-scrollbar {
  width: 6px;
}

.section-content::-webkit-scrollbar-track {
  background: #f8fafc;
  border-radius: 3px;
}

.section-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.section-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Mobile Responsive Design */
@media (max-width: 768px) {
  .notes-transcription-popover {
    width: calc(100vw - 20px) !important;
    max-width: 350px !important;
    left: 10px !important;
    right: 10px !important;
    transform: none !important;
  }

  .notes-transcription-popover .popover-body {
    width: 100% !important;
    max-width: 100% !important;
  }

  .popover-content {
    width: 100%;
    max-height: 60vh;
  }

  .section-content {
    max-height: 25vh;
  }

  .section-header {
    padding: 6px 10px;
  }

  .content-item {
    padding: 6px 8px;
  }

  .item-content {
    font-size: 11px;
    line-height: 1.2;
  }

  .item-time {
    font-size: 9px;
  }

  .section-label {
    font-size: 11px;
  }

  .section-count {
    font-size: 10px;
  }
}

/* Small phones */
@media (max-width: 480px) {
  .notes-transcription-popover {
    width: calc(100vw - 16px) !important;
    max-width: none !important;
    left: 8px !important;
    right: 8px !important;
  }

  .popover-content {
    max-height: 50vh;
  }

  .section-content {
    max-height: 20vh;
  }

  .section-header {
    padding: 4px 8px;
  }

  .content-item {
    padding: 4px 6px;
  }

  .item-content {
    font-size: 10px;
  }

  .item-time {
    font-size: 8px;
  }

  .section-label {
    font-size: 10px;
  }
}

/* Force mobile positioning */
@media (max-width: 768px) {
  .notes-transcription-popover.bs-popover-top .arrow,
  .notes-transcription-popover.bs-popover-bottom .arrow,
  .notes-transcription-popover.bs-popover-left .arrow,
  .notes-transcription-popover.bs-popover-right .arrow {
    display: none !important;
  }

  .notes-transcription-popover {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    z-index: 9999 !important;
  }
}
</style>